<template>
  <div class="mx-auto w-11/12 sm:w-7/12 sm:min-w-150 mt-2 sm:mt-12 max-w-4xl">
    <div class="sm:flex">
      <img
        class="block mx-auto sm:mx-0 w-48"
        src="@/assets/files.svg"
        alt="create account"
      >
      <div class="self-center sm:ml-2 text-2xl sm:text-4xl font-bold sm:text-left">
        Cuéntanos de ti
      </div>
    </div>
    <generic-form
      v-if="showForm"
      :structure="structure"
      :preloadValues="preloadValues"
      :extraLoad="{ instanceID: instanceID || '' }"
      :action="action"
      submitText="Guardar"
      @response="handleResponse"
      @error="handleError"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import GenericForm from './genericForm'
export default {
  components: {
    GenericForm,
  },
  props: {
    loadInfo: { type: Boolean, default: false },
    action: { type: String, default: '/instances/update' },
  },
  data () {
    return {
      structure: [
        {
          groupName: 'Información general',
          inputs: [
            {
              id: 'instanceName',
              type: 'text',
              label: 'Nombre empresa',
              validation: { regex: /^[0-9a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\-. ' ]*$/, required: true },
            },
            {
              id: 'NIT',
              type: 'number',
              label: 'NIT (sin dígito de verificación)',
              validation: 'required|numeric',
            },
            {
              id: 'instanceLogo',
              type: 'file',
              label: 'Carga el logo de tu empresa',
              validation: 'image',
            }
          ],
        },
        {
          groupName: 'Contacto',
          inputs: [
            {
              id: 'contactName',
              type: 'text',
              label: 'Nombre contacto principal',
              validation: { regex: /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\-' ]*$/, required: true },
            },
            {
              id: 'jobTitle',
              type: 'text',
              label: 'Cargo',
              validation: { regex: /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\-' ]*$/, required: true },
            },
            {
              id: 'email',
              type: 'text',
              label: 'email',
              validation: 'required|email',
            }
          ],
        }
      ],
    }
  },
  computed: {
    showForm () {
      if (this.loadInfo) {
        return Object.keys(this.instancesInfo[this.instanceID]).length
      }
      return true
    },
    preloadValues () {
      if (this.loadInfo && Object.keys(this.instancesInfo[this.instanceID]).length) {
        return {
          instanceName: this.instancesInfo[this.instanceID].name,
          NIT: this.instancesInfo[this.instanceID].NIT,
          contactName: this.instancesInfo[this.instanceID].contactInfo.name,
          jobTitle: this.instancesInfo[this.instanceID].contactInfo.jobTitle,
          email: this.instancesInfo[this.instanceID].contactInfo.email,
        }
      } else {
        return {}
      }
    },
    ...mapState({
      instancesInfo: state => state.auth.instancesInfo,
      instanceID: state => state.admin.instanceID,
    }),
  },
  methods: {
    handleResponse (response) {
      console.info(response)
    },
    handleError (err) {
      console.error(err)
    },
  },
}
</script>
